import { render } from "./pdf-viewer.vue?vue&type=template&id=74820bcc&ts=true"
import script from "./pdf-viewer.vue?vue&type=script&lang=ts"
export * from "./pdf-viewer.vue?vue&type=script&lang=ts"

import exportComponent from "/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__